import React from 'react';
import { useTranslation } from 'react-i18next';

import OrderCard from "../../jo-components/cards/orderCard/orderCard";
import EmptyState from "../../jo-components/misc/emptyState/emptyState";
import Message from "../../resale/seller/components/message";
import ItemCardInfos from "../../jo-components/cards/itemCard/components/itemCardInfos/itemCardInfos";

export function OrderList({ config, onSubmit=()=>{}, storage }) {
    const { t } = useTranslation();
    const messages = config['messages'];
    const orders = config['orders'];

    const getOrderMainAction = React.useCallback((order) => {
        if (!order?.actions?.length) return null;
        const hasOrderMenu = order.actions.find(action => action.type === 'OrderMenuStep' && action.enabled);
        if (hasOrderMenu)
            return {
                label: t('widget.button.manage.default_label'),
                icon: "arrowRight",
                onClick: () => {onSubmit({
                    data: {
                        action: 'OrderMenuStep',
                        order_id: order.id
                    }
                })}
            }
        return null;
    }, [onSubmit]);

    return (
        <div className={'wz-order-list'}>
            {messages?.map((message, index) => (
                <Message key={index} description={message.subtitle} {...message} />
            ))}
            {orders?.length ? (
                <>
                    {orders.map((order, index) => (
                        <OrderCard key={index} order={order} action={getOrderMainAction(order)} event={order.event}>
                            <ItemCardInfos title={order?.informations_title} informations={order?.informations} />
                        </OrderCard>
                    ))}
                </>
            ) : (
                <EmptyState
                    icon={'ticket'}
                    title={t('widget.empty.tickets.title')}
                    subtitle={t('widget.empty.tickets.subtitle')}
                />
            )}
        </div>
    );
}